import {
  StudyParticipant,
  StudyParticipantStatus
} from '../models/StudyParticipant';

export type StudyDisplayStatus =
  'planning' | 'progress' | 'completed' | 'withdrawn' | 'screenFailed';

/** The server's status in the app's display terms, so the app and portal never disagree. */
export function toStudyDisplayStatus(
  studyParticipant?: Pick<StudyParticipant, 'status'>
): StudyDisplayStatus {
  switch (studyParticipant?.status) {
    case StudyParticipantStatus.Withdrawn:
      return 'withdrawn';
    case StudyParticipantStatus.ScreenFailed:
      return 'screenFailed';
    case StudyParticipantStatus.Completed:
    case StudyParticipantStatus.ClosedOut:
      return 'completed';
    case StudyParticipantStatus.Consented:
    case StudyParticipantStatus.Enrolled:
      return 'progress';
    default:
      return 'planning';
  }
}

/** Studies the participant is no longer taking part in. */
export function isEndedDisplayStatus(status: StudyDisplayStatus) {
  return (
    status === 'completed' ||
    status === 'withdrawn' ||
    status === 'screenFailed'
  );
}

export type StudyParticipantWithDisplayStatus = StudyParticipant & {
  displayStatus: StudyDisplayStatus;
};

/** The My Studies tab a participation is listed under; a disqualified one that has not ended is in neither. */
export function myStudiesTab(
  studyParticipant: Pick<
    StudyParticipantWithDisplayStatus,
    'displayStatus' | 'disqualified'
  >
): 'past' | 'active' | undefined {
  if (isEndedDisplayStatus(studyParticipant.displayStatus)) return 'past';
  return studyParticipant.disqualified ? undefined : 'active';
}
